module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/tide-software-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e71044ad3ceea5b9974de3baee6d3f26"},
    },{
      plugin: require('../node_modules/@qite/gatsby-source-tide/gatsby-browser.js'),
      options: {"plugins":[],"host":"https://tide-commercial3791.tidesoftware.be/","apiKey":"824ae793-e6cb-4773-ac40-2669bf18ee8d","ignoreSslErrors":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
